<div class="navigation flex items-center container">
  <vex-navigation-item *ngFor="let item of items$ | async" [item]="item"></vex-navigation-item>
</div>

